import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { CompanyHeaderField } from "./CompanyHeaderField"

import DisplayIds from "@/components/common/DisplayIds/DisplayIds"
import type { Company, Location } from "@/graphql/codegen/graphql"
import { formatMeasurementSystemUoM } from "@/screens/Companies/utils/company"
import { AddressFormat } from "@/types/common"
import { formatLocationAddress } from "@/utils/utils"

interface CompanyHeaderCardProps {
  company: Company
  shipToLocation: Location
  datePreference: string
}

export const CompanyHeaderCard: FC<CompanyHeaderCardProps> = ({ company, shipToLocation, datePreference }) => {
  // AK-5932: Company.billingLocation isn't resolved server-side — read it via the company_location_association row instead.
  const billToLocation = company.locationsAssociations?.find((association) => association.billing)?.billing

  return (
    <Box className='rounded-md border border-solid border-gray-400 p-6'>
      <Box className='flex items-center gap-6'>
        <Typography variant='h5' className='text-gray-800'>
          {company.name}
        </Typography>

        <DisplayIds
          entityName='Company ID'
          publicId={company.publicId}
          externalSystemId={company.customerExternalSystemId?.toString()}
        />
      </Box>

      <Box className='mt-6 flex flex-wrap items-center gap-6'>
        <CompanyHeaderField
          label='Ship To'
          value={formatLocationAddress(shipToLocation, AddressFormat.LocationAndAddress)}
          chipColor='primary'
        />
        <CompanyHeaderField
          label='Bill To'
          value={formatLocationAddress(billToLocation, AddressFormat.LocationAndAddress) || "-"}
          chipColor='primary'
        />
        <CompanyHeaderField label='Date Preference' value={datePreference} />
        <CompanyHeaderField
          label='Unit of Measure'
          value={formatMeasurementSystemUoM(company.preferredMeasurementSystem, company.defaultUom ?? undefined)}
        />
      </Box>
    </Box>
  )
}
